export default __webpack_public_path__ + "static/media/Oxford.3e1afd0f.png";